function Legal()
    {
        return (
            <main>
                <p>mentions légales</p>
            </main>
        )
    }

export default Legal;